export default "/images/256ad5027a8528f0025f1bd3f3e44336.avif";